import { usePagination } from 'react-instantsearch';

import Pagination from './Pagination';

interface Props {
  className?: string;
}

export default function AlgoliaPagination({ className }: Props) {
  const {
    currentRefinement,
    nbPages,
    isFirstPage,
    isLastPage,
    canRefine,
    refine,
  } = usePagination();

  if (!canRefine) {
    return null;
  }

  return (
    <Pagination
      className={className}
      currentPage={currentRefinement + 1}
      totalPages={nbPages}
      hasPrevPage={!isFirstPage && nbPages > 1}
      hasNextPage={!isLastPage && nbPages > 1}
      handlePrevPage={() => refine(currentRefinement - 1)}
      handleNextPage={() => refine(currentRefinement + 1)}
      handleGoToPage={(page: number) => refine(page - 1)}
    />
  );
}
